<template>
  <div class="row breadcrumbs-top">
    <div class="col-12">
      <h2 class="content-header-title float-left mb-0">{{ name }}</h2>
      <div class="breadcrumb-wrapper" v-if="bc1">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <a href="javascript:void(0)"><router-link to="/">{{ bc1 }}</router-link></a>
          </li>
          <li v-if="bc2" class="breadcrumb-item">
            <a href="javascript:void(0)"
              ><router-link :to="{ name: path }">{{ bc2 }}</router-link></a
            >
          </li>
          <li v-if="bc3" class="breadcrumb-item active">
            <a href="javascript:void(0)">{{ bc3 }}</a>
          </li>
        </ol>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["name", "bc1", "bc2", "bc3", "path"],
  mounted() {},
  data() {
    return {};
  }
};
</script>

